export const priceSr = {
  en: {
    "Original price": "Original price",
    "Sale price": "Sale price",
    "Price": "Price",
  },
  de: {
    "Original price": "Originalpreis",
    "Sale price": "Angebotspreis",
    "Price": "Preis",
  },
} as const
